const SET_JOB_LIST = 'SET_JOB_LIST';
const SET_JOB = 'SET_JOB';
const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
const SET_MODAL_AGENT_OPEN = 'SET_MODAL_AGENT_OPEN';
const SET_MODAL_SUCCESS_OPEN = 'SET_MODAL_SUCCESS_OPEN';
const SET_FORM_JOB_POSITION = 'SET_FORM_JOB_POSITION';
const SET_LOADING = 'SET_LOADING';

const combineConst = {
    SET_JOB_LIST,
    SET_JOB,
    SET_MODAL_OPEN,
    SET_MODAL_AGENT_OPEN,
    SET_MODAL_SUCCESS_OPEN,
    SET_FORM_JOB_POSITION,
    SET_LOADING
};

export default combineConst;
